var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyTaskList(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "48px",
    viewBox: "0 0 50 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "check-circle") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M5.71602139,10.516215 C12.5738503,2.49256406 23.8923664,-0.0647050032 33.5336346,4.23119307 C34.6266583,4.71821598 35.117919,5.99909684 34.6308961,7.09212055 C34.1438732,8.18514426 32.8629923,8.67640498 31.7699686,8.18938207 C23.8816583,4.67455637 14.6210542,6.76686743 9.01010328,13.3316728 C3.39915232,19.8964781 2.77447602,29.3699321 7.47483102,36.6146614 C12.175186,43.8593907 21.0808698,47.1495805 29.3624058,44.700989 C37.6439418,42.2523974 43.3285308,34.6483195 43.3334683,26.0136209 L43.3334683,26.0136209 L43.3334683,23.9986209 C43.3334683,22.8020039 44.303518,21.8319542 45.5001349,21.8319542 C46.6967519,21.8319542 47.6668016,22.8020039 47.6668016,23.9986209 L47.6668016,23.9986209 L47.6668016,26.0148597 C47.6607662,36.5698944 40.7129352,45.8637673 30.5910578,48.8564904 C20.4691805,51.8492134 9.58445585,47.8278703 3.83957752,38.9732012 C-1.90530082,30.118532 -1.14180756,18.539866 5.71602139,10.516215 Z M46.1347369,4.98155621 C46.9808729,4.13542024 48.3527303,4.13542024 49.1988663,4.98155621 C50.0450022,5.82769218 50.0450022,7.19954963 49.1988663,8.0456856 L49.1988663,8.0456856 L25.3655329,31.8790189 C24.519397,32.7251549 23.1475395,32.7251549 22.3014036,31.8790189 L22.3014036,31.8790189 L15.8014036,25.3790189 C14.9552676,24.532883 14.9552676,23.1610255 15.8014036,22.3148895 C16.6475395,21.4687536 18.019397,21.4687536 18.8655329,22.3148895 L18.8655329,22.3148895 L23.8334683,27.2828249 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.100000001
  }, /*#__PURE__*/React.createElement("g", {
    id: "task2-14",
    transform: "translate(-543.000000, -595.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(543.000000, 592.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "check-circle",
    transform: "translate(0.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Combined-Shape",
    fill: "#000000",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    mask: "url(#mask-2)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "COLOR/-black"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 52,
    height: 52
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyTaskList);
export default __webpack_public_path__ + "static/media/empty-task-list.8a23d415434d60c9105a3030622dd9d3.svg";
export { ForwardRef as ReactComponent };